import { reduxForm, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import Form from '../Components/Form'

import validate from './validate'
import onSubmit from './onSubmit'
import onSubmitFail from './onSubmitFail'

export const FORM_NAME = 'Setting'

const formConfig = {
  form: FORM_NAME,
  initialValues: {},
  validate,
  onSubmit,
  onSubmitFail,
}

// Create the Redux Form enhanced component
const ReduxFormComponent = reduxForm(formConfig)(Form)

// Connect to get form values and pass them as props
const selector = formValueSelector(FORM_NAME)
const mapStateToProps = (state) => ({
  formValues: {
    value: selector(state, 'value')
  },
})

export default connect(mapStateToProps)(ReduxFormComponent)
